export const PERMS = {
    READ: 'transporeon_offers.read',
    UPDATE: 'transporeon_offers.update',
    EXPORT: 'transporeon_offers.export',
}
